import { parsePrice } from './parsePrice';
import { parsePercentage } from './parsePercentage';
import { getFont } from './getFont';
import { getSiteProcessStatusName, getOrderCategoryName } from './constLabel';
import {
  convertApiDateToFormDate,
  convertFormDateToApiDate
} from './convertDateFormat';
import {
  createSiteTaskFormMerchandiseOrderList,
  createSiteTaskFormOrderDisplayName,
  createSiteTaskFormOutSourceOrderList,
  createSiteTaskFormProcessListPulldown,
  createSiteProcessAndSiteTaskEmployeeList,
  createSiteProcessFormProcessListPulldown
} from './processAndTaskFormUtils';
import {
  convertToFullCalendarDateString,
  convertToFullCalendarEndDateString,
  convertToFullCalendarId,
  createGanttEvent,
  createGanttResource,
  getEventBackgroundColor,
  getEventTextColor,
  getOrder,
  getSiteProcessVisibleRange,
  validateGanttPeriod
} from './processGantChartUtils';
import { getRokuyo } from './getRokuyo';
import * as log from './actionLog';
export {
  parsePrice,
  parsePercentage,
  getFont,
  log,
  getSiteProcessStatusName,
  getOrderCategoryName,
  createSiteProcessAndSiteTaskEmployeeList,
  convertApiDateToFormDate,
  convertFormDateToApiDate,
  createSiteTaskFormMerchandiseOrderList,
  createSiteTaskFormOrderDisplayName,
  createSiteTaskFormOutSourceOrderList,
  createSiteTaskFormProcessListPulldown,
  createSiteProcessFormProcessListPulldown,
  convertToFullCalendarDateString,
  convertToFullCalendarEndDateString,
  convertToFullCalendarId,
  createGanttEvent,
  createGanttResource,
  getEventBackgroundColor,
  getEventTextColor,
  getOrder,
  getSiteProcessVisibleRange,
  validateGanttPeriod,
  getRokuyo
};

export function toPdfStr(inStr: string): string {
  return inStr.replaceAll('　', ' ');
}

export function splitConstructSub(str: string, length: number) {
  // 工事件名を各種帳票に出力するための2行に成形
  // 改行コードを半角スペースに置き換え
  const newlineRegex = /\r\n|\n|\r/g;
  const sanitizedStr = str.replace(newlineRegex, ' ');

  // 指定文字数で分割して、firstLine と secondLine を取得
  const firstLine = sanitizedStr.substr(0, length);
  const secondLine = sanitizedStr.substr(length);

  return { firstLine: firstLine, secondLine: secondLine };
}
